import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { comics } from '@/mocks/comics';
import { getCategoryName } from '@/utils/comicHelpers';
import ComicCard from '@/components/base/ComicCard';
import SectionHeader from '@/components/base/SectionHeader';

export default function CategoryBrowse() {
  const [active, setActive] = useState('all');

  const filtered =
    active === 'all'
      ? comics.slice(0, 6)
      : comics.filter((c) => c.categories.includes(active)).slice(0, 6);

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeader
        title="分类专区"
        subtitle="按题材挑选，总有一部合你口味"
        moreTo={active === 'all' ? '/category' : `/category/${active}`}
        moreLabel={active === 'all' ? '全部漫画' : `更多${getCategoryName(active)}漫画`}
      />

      <div className="mb-6 flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => setActive('all')}
          className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
            active === 'all'
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
          }`}
        >
          全部
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            onClick={() => setActive(cat.id)}
            className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
              active === cat.id
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-6">
        {filtered.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to={active === 'all' ? '/category' : `/category/${active}`}
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-primary-200 px-6 py-2 text-sm text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50"
        >
          {active === 'all' ? '浏览全部漫画' : `查看全部${getCategoryName(active)}漫画`}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
    </section>
  );
}